import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import OTPVerification from "./pages/OTPVerification";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Transactions from "./pages/Transactions";
import Settings from "./pages/Settings";
import Wallet from "./pages/Wallet";
import Arbitrage from "./pages/Arbitrage";
import MLMTeam from "./pages/MLMTeam";
import Withdrawal from "./pages/Withdrawal";
import IncomeBonus from "./pages/IncomeBonus";
import TradingPerformance from "./pages/TradingPerformance";
import TeamMemberDetails from "./pages/TeamMemberDetails";
import Reports from "./pages/Reports";
import TradeHistory from "./pages/TradeHistory";
import ProfileSecurity from "./pages/ProfileSecurity";
import ProfitSummary from "./pages/ProfitSummary";
import TradeLogs from "./pages/TradeLogs";
import MyDirect from "./pages/MyDirect";
import MLMTeamTree from "./pages/MLMTeamTree";
import MLMLevelDetails from "./pages/MLMLevelDetails";
import LevelWiseBusiness from "./pages/LevelWiseBusiness";
import DirectLegBusiness from "./pages/DirectLegBusiness";
import HelpCenter from "./pages/HelpCenter";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import About from "./pages/About";
function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes - No Authentication Required */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/otp-verification" element={<OTPVerification />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Protected Routes - Require Authentication */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transactions"
          element={
            <ProtectedRoute>
              <Transactions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/arbitrage"
          element={
            <ProtectedRoute>
              <Arbitrage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mlm-team"
          element={
            <ProtectedRoute>
              <MLMTeam />
            </ProtectedRoute>
          }
        />
        <Route
          path="/withdrawal"
          element={
            <ProtectedRoute>
              <Withdrawal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/income-bonus"
          element={
            <ProtectedRoute>
              <IncomeBonus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staking"
          element={
            <ProtectedRoute>
              <Navigate to="/dashboard" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trading-performance"
          element={
            <ProtectedRoute>
              <TradingPerformance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/team-member-details/:memberId"
          element={
            <ProtectedRoute>
              <TeamMemberDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bot-settings"
          element={<Navigate to="/dashboard" replace />}
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profit-summary"
          element={
            <ProtectedRoute>
              <ProfitSummary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trade-logs"
          element={
            <ProtectedRoute>
              <TradeLogs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-direct"
          element={
            <ProtectedRoute>
              <MyDirect />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mlm-team-tree"
          element={
            <ProtectedRoute>
              <MLMTeamTree />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mlm-level-details"
          element={
            <ProtectedRoute>
              <MLMLevelDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/level-wise-business"
          element={
            <ProtectedRoute>
              <LevelWiseBusiness />
            </ProtectedRoute>
          }
        />
        <Route
          path="/direct-leg-business"
          element={
            <ProtectedRoute>
              <DirectLegBusiness />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet"
          element={
            <ProtectedRoute>
              <Wallet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-security"
          element={
            <ProtectedRoute>
              <ProfileSecurity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/help-center"
          element={
            <ProtectedRoute>
              <HelpCenter />
            </ProtectedRoute>
          }
        />
        <Route
          path="/terms-of-service"
          element={
            <ProtectedRoute>
              <TermsOfService />
            </ProtectedRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <ProtectedRoute>
              <PrivacyPolicy />
            </ProtectedRoute>
          }
        />
        <Route
          path="/about"
          element={
            <ProtectedRoute>
              <About />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
